export function AdminPanelFooter({ buttonText, onButtonClick }) {
  return (
    <div className="admin-panel__form-footer">
      <button type="button" onClick={onButtonClick}>
        {buttonText}
      </button>
    </div>
  );
}
